module.exports = __webpack_public_path__ + "media/src/shared_components/images/plus_icon-adf2e92eeb3a95086ebd3e1fbfc3e9d5.svg";